<template lang="pug">
div(v-if="openCall")
  b-card(no-body, text-variant="white").call.d-flex.justify-content-between.align-items-center.flex-row
    div(v-if="!isCalling").mx-3.d-flex.align-items-center
      Avatar(size="xs", :src="userData.profile_pic", platform="voip")
      span.ml-4 Llamando a {{ userName }}...
    div(v-if="isCalling").d-flex.align-items-center.mx-3
      div.mr-3
        Avatar(size="xs", :src="userData.profile_pic", platform="voip")
      span.mr-2 Llamada en curso
      span {{ callCounting }}
    div(v-if="!isCalling").m-3
      b-button(@click="disconnect", style="background-color: #FF4D4F; .border:active, .border:focus { outline: none; box-shadow: none; }").buttonStyle
        x-icon(stroke='white', fill='white').icon-sm
      b-avatar(style="background-color: #52B366").m-2.pulser
        phone-icon(fill="white", stroke="none").icon-sm
    div.m-3(v-if="isCalling")
      b-button(@click="mute", :style="{ backgroundColor: 'white' }").m-2.buttonStyle
        mic-icon(v-if="!isMuted").icon-sm(stroke='#000000', fill='none')
        mic-off-icon(v-if="isMuted").icon-sm(stroke='#000000', fill='none')
      b-button(v-if="canRedirect", @click="isToForward = true", :style="{ backgroundColor: 'white' }").buttonStyle
        phone-forwarded-icon.icon-sm(stroke='#000000', fill='none')
      b-button(@click="disconnect", :style="{ backgroundColor: '#FF4D4F' }").m-2.buttonStyle
        x-icon(stroke='white', fill='white').icon-sm

  b-modal(
    size="md",
    button-size="sm",
    v-model="isToForward",
    cancel-title="Cancelar",
    cancel-variant="transparent",
    ok-title="Transferir",
    ok-variant="primary",
    hide-header-close,
    @ok="callForwarded"
  )
    template(#modal-header)
      b-row(align-v="center").mx-auto
        b-col(align-self="center").text-center
          p.mb-1 Transferir llamada
          b-avatar(@click="isToForward = true", style="background-color: #E2E6ED").buttonStyle
            phone-forwarded-icon.icon-sm(stroke='#000000', fill='black')
    div
      b-input-group(size="sm")
        b-form-input(type="search", placeholder="Buscar agente", @input="findAgent($event)")
        b-input-group-append
          b-input-group-text
            search-icon.text-dark.icon-sm
      hr
      b-tabs(small, nav-class="flex-nowrap scrollable-area overflow-hidden overflow-x pb-1")
        b-tab(
          v-for="(name, index) of groupsName",
          :key="index",
          :title="name"
        ).scrollable-area.overflow-x
          b-form-group
            b-table(
              :fields="agentsFields",
              :items="sortAgentsInGroups(name)",
              hover,
              selectable,
              responsive,
              show-empty,
              sticky-header,
              select-mode="single",
              thead-tr-class="d-none",
              @row-selected="agentSelected",
            ).m-0.overflow-y.scrollable-area.text-center
              template(#empty)
                p.mb-0.text-help No hay agentes para mostrar
              template(#cell(image)="row")
                div.d-flex.justify-content-center.align-items-center
                  b-avatar(v-if="row.item.image", :src="row.item.image", :text="row.item.image", variant="soft-secondary").mr-3
              template(#cell(fullName)="row")
                div.d-flex.flex-column.justify-content-center.align-items-start
                  span {{ row.item.fullName.name }}
                  span.text-secondary.text {{ row.item.fullName.email }}
              template(#cell(status)="row")
                div.d-flex.justify-content-center.align-items-center
                  b-badge(pill :variant="getStatusColor(row.item.status)") {{ row.item.status }}
</template>

<script>
import Avatar from './Avatar.vue'
import { createNamespacedHelpers, mapActions } from 'vuex'
import { EventBus } from '../helpers/eventBus'

const caseController = createNamespacedHelpers('case')

export default {
  data: () => {
    return {
      timeCounter: '',
      adminEmail: '',
      openCall: false,
      canRedirect: false,
      groupsName: [],
      agentsFields: ['image', 'fullName', 'status'],
      groupsToFilter: [],
      agents: [],
      getAgents: [],
      allowedCharacters: '^[0-9*#]+$',
      keys: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'],
      number: '',
      name: '',
      screenName: '',
      isMuted: false,
      isToForward: false,
      redirectTo: '',
      isCalling: false,
      conversation: null,
      externalId: null,
      callCounter: '',
      user: null,
      callCaseObject: null,
      totalSeconds: 0
    }
  },
  props: {
    isCallPanelOpen: {
      type: Boolean,
      default: false
    },
    caller: {
      type: Object,
      default: () => {
        return {}
      }
    },
    call: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: ''
    },
  },
  computed: {
    ...caseController.mapState({
      case_object: state => state.case_object
    }),
    userData() {
      if (this.callCaseObject && this.callCaseObject.User) {
        this.user = this.callCaseObject.User

        return this.user
      }

      return this.user || {}
    },
    userName() {
      if (this.user && (this.user.first_name || this.user.last_name)) {
        return `${this.user.first_name || ''} ${this.user.last_name || ''}`
      } else if (this.user && (this.user.external_id)) {
        return this.user.external_id || 'Usuario'
      } else {
        return 'Usuario'
      }
    },
    callCounting() {
      const hours = Math.floor(this.totalSeconds / 3600)
      const minutes = Math.floor((this.totalSeconds % 3600) / 60)
      const seconds = this.totalSeconds % 60

      const formattedHours = this.padNumber(hours)
      const formattedMinutes = this.padNumber(minutes)
      const formattedSeconds = this.padNumber(seconds)

      this.callCounter = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`

      return this.callCounter
    },
  },
  methods: {
    ...mapActions([
      'account/getAdminAgents',
      'case/get',
      'admin/get',
      'conversation/get'
    ]),
    padNumber(value) {
      return value.toString().padStart(2, '0')
    },
    startCounter() {
      this.$store.commit('account/setShowCallCounting', true)

      this.intervalId = setInterval(() => {
        this.totalSeconds++
      }, 1000)
    },
    stopCounter() {
      this.$store.commit('account/setShowCallCounting', false)

      this.totalSeconds = 0
      this.callCounter = ''

      clearInterval(this.intervalId)
    },
    async getCase() {
      if (!this.$route.params.case_id) return
      const self = this

      await this['case/get']({
        case_id: self.$route.params.case_id,
        params: { account_id: self.$route.params.account_id },
        soft: true,
        callback: async (res) => {
          if (res.error) return self.$message.error(res.error)
          if (!res.resource) return

          this.number = this.replacePhoneNumber(res.resource.User.external_id)
          this.user = res.resource.User || {}
          this.screenName = res.resource.User.screen_name || res.resource.User.external_id
          this.externalId = res.resource.User.external_id
        }
      })
    },
    replacePhoneNumber(number) {
      if (/^521/.test(number)) {
        return number.replace(/^521/, '+52')
      } else if (/^52/.test(number)) {
        return number.replace(/^52/, '+52')
      } else {
        return number
      }
    },
    deleteSpecialCharacters(string) {
      if (!string) return string

      const accents = {
        á: 'a',
        é: 'e',
        í: 'i',
        ó: 'o',
        ú: 'u',
        Á: 'A',
        É: 'E',
        Í: 'I',
        Ó: 'O',
        Ú: 'U'
      }

      string = string.replace(/\./g, '')
      string = string.replace(/\s/g, '')
      string = string.replace(/[áéíóúÁÉÍÓÚ]/g, (letter) => accents[letter])
      string = string.replace(/[^\w\s]/g, '')

      return string
    },
    async hangUpCall() {
      this.openCall = false
      this.isCalling = false
      this.isMuted = false
      this.callCaseObject = null
      const params = { callId: this.call.parameters.CallSid }

      EventBus.$emit('putIsCallPanelOpen', false)
      this.stopCounter()
      this.call.disconnect()

      if (this.caller) await this.caller.deleteCall(params)
    },
    async callForwarded(event) {
      event.preventDefault()

      if (!this.call.parameters.CallSid || !this.redirectTo) {
        return this.$message.error('No se puede transferir la llamada')
      }

      const params = {
        callId: this.call.parameters.CallSid,
        email: this.redirectTo
      }

      EventBus.$emit('putIsCallPanelOpen', false)
      this.getAdminAgents()
      await this.caller.redirectCall(params)
    },
    agentSelected(items) {
      if (!items || !items[0] || !items[0].fullName) return

      this.redirectTo = items[0].fullName.email
    },
    getStatusColor(status) {
      const color = {
        Disponible: 'success',
        'No estatus': 'soft-secondary',
        offline: 'soft-danger'
      }[status]

      return color
    },
    sortAgentsInGroups(name) {
      if (name === 'Todos') return this.getAgents

      const filteredAgents = this.getAgents.filter((admin) => {
        const group = this.groupsToFilter.find((group) => group.name === name)

        if (group && group.admins.includes(admin.adminId)) return true

        return false
      })

      return filteredAgents
    },
    findAgent(agentToFind) {
      if (agentToFind) {
        const agentsFound = this.agents.filter(({ fullName }) => {
          const agentNameLowerCase = fullName.name.toLowerCase()
          const agentToFindLowerCase = agentToFind.toLowerCase()

          return agentNameLowerCase.startsWith(agentToFindLowerCase)
        })

        if (!agentsFound.length) {
          this.getAgents = []
          return
        }

        this.getAgents = JSON.parse(JSON.stringify(agentsFound))
      } else {
        this.getAgents = this.agents
      }
    },
    async makeACall() {
      if (!this.caller || !this.token) return

      this.callCaseObject = JSON.parse(JSON.stringify(this.case_object || this.user))

      this.caller.call(this.number, this.token)
    },
    disconnect() {
      this.$bvModal.msgBoxConfirm('Presiona aceptar para terminar la llamada', {
        title: '¿Quieres finalizar la llamada?',
        size: 'md',
        buttonSize: 'sm',
        okTitle: 'Aceptar',
        okVariant: 'primary',
        cancelVariant: 'transparent',
        cancelTitle: 'Cancelar',
        headerClass: 'p-3 border-bottom-0',
        footerClass: 'p-3 border-top-0',
        centered: true
      }).then(async (value) => {
        if (!value) return

        this.$store.commit('account/setShowCallCounting', false)
        EventBus.$emit('putIsCallPanelOpen', false)

        return await this.hangUpCall()
      })
    },
    mute() {
      this.isMuted = !this.isMuted

      return this.call.mute(this.isMuted)
    },
    getAdminAgents() {
      this['account/getAdminAgents']({
        accountId: this.$route.params.account_id,
        callback: (res) => {
          if (res.error) return this.$message.error(res.error)

          this.groupsToFilter = Object.values(res.resource.groups)
          this.agents = res.resource.admins.map(({
            admin_id: adminId,
            image,
            first_name: firstName,
            last_name: lastName,
            email,
            status
          }) => {
            return {
              adminId,
              image: image || firstName.charAt(0),
              fullName: {
                name: `${firstName} ${lastName}` || 'Sin nombre',
                email: email || 'Sin email'
              },
              status: (status === 'default' || !status) ? 'No estatus' : status
            }
          })

          this.groupsName = Object.values(res.resource.groups)
            .map(group => group.name)

          this.groupsName.unshift('Todos')

          this.getAgents = this.agents
        }
      })
    },
    async getConversation() {
      if (this.$route.path.includes('cases') || !this.$route.params.conversation_id) return
      const self = this

      await this['conversation/get']({
        conversation_id: self.$route.params.conversation_id,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)

          self.number = this.replacePhoneNumber(res.resource.user.external_id)
          self.user = res.resource.user || {}
        }
      })
    },
  },
  async mounted() {
    this.getAgents = this.agents

    EventBus.$on('putBuildCallData', ({ keys = [], value = false }) => {
      keys.forEach(key => { this[key] = value })
    })
    EventBus.$on('pleaseStopCounter', () => { this.stopCounter() })
    EventBus.$on('pleaseStartCounter', () => { this.startCounter() })
    EventBus.$on('putCaseId', (value) => { this.case_id = value })
    EventBus.$on('updateCallUser', () => { this.getCase() })
    EventBus.$on('hangUpCallWhenReset', () => { this.hangUpCall() })

    this.getAdminAgents()
    if (this.$route.path.includes('cases')) return await this.getCase()
  },
  beforeUnmount() {
    EventBus.$off('putIsCallPanelOpen')
  },
  watch: {
    async isCallPanelOpen() {
      if (this.isCallPanelOpen) {
        this.openCall = true
        if (this.$route.path.includes('chats')) {
          await this.getConversation()
        } else {
          await this.getCase()
        }

        return this.makeACall()
      }
    },
    callCounter() {
      EventBus.$emit('putCallCounter', this.callCounter)
    },
    isToForward() {
      this.getAdminAgents()
    },
    isCalling() {
      const onCall = this.isCalling && this.call

      if (onCall && this.call.callerInfo !== 'Inbound') {
        setTimeout(() => {
          this.canRedirect = true
        }, 20000)
      } else if (onCall && this.call.callerInfo === 'Inbound') {
        this.canRedirect = true
      } else {
        this.canRedirect = false
      }
    }
  },
  components: {
    Avatar
  }
}
</script>

<style lang="scss" scoped>
.call {
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
  background-color: rgba(48, 49, 53, 0.95);
}
.platform-tabs-flex {
  display: flex;
  flex-wrap: nowrap !important;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}
.margin {
  margin-top: 70px;
}
.input {
  border: none;
  font-weight: bold;
  color: black;
}
.buttonStyle {
  border-radius: 200px;
  height: 40px;
  width: 40px;
  border: none;
}
.draggable-component {
  display: flex;
  justify-content: center !important;
  align-content: center !important;
  width: 250px;
  max-width: 250px;
  height: 400px;
  max-height: 400px;
  background-color: #FFFFFF;
  position: absolute;
  top: 22px;
  border-radius: 10px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
}

.pulser {
  animation: pulse 0.4s infinite alternate;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
</style>
